import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faTh } from '@fortawesome/free-solid-svg-icons';
//global components
import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from '../../_services/menu.service';
import { productService } from '../../_services/product.service';
import { categoryService } from '../../_services/category.service';
import { tagService } from '../../_services/tag.service';
import { cartService } from '../../_services/cart.service';
import { formatPrice } from "../../_helpers";

import Swal from 'sweetalert2/dist/sweetalert2.js'
//styles
import "./ProductList.sass";
import { postService } from '../../_services/post.service';
import { settingsService } from '../../_services/settings.service';


class ProductList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {}
      },
      menu: {},
      topbarMenu: {},
      category: {},
      products: [],
      defaultProducts: {},
      checkedTags: [],
      tags: {},
      branches: {},
      categories: {},
      catwoo:[],
      displayList: false,
      productsRange: [
        { value: '500 - 2,500' },
        { value: '2,501 - 5,000' },
        { value: '5,001 - 10,000' },
        { value: '10,001 - 30,000' },
        { value: '30,001 - higher' }
      ],
      productsSort: [
        { name: 'Newest', sortBy: 'newest' },
        { name: 'Oldest', sortBy: 'oldest' },
        { name: 'Price (Low to High)', sortBy: 'low-to-high' },
        { name: 'Price (High to Low)', sortBy: 'high-to-low' },
        { name: 'Description A-Z', sortBy: 'desc-a-z' },
        { name: 'Description Z-A', sortBy: 'desc-z-a' },
      ],
      sortBy: '',
      priceRange: [],
      checkedItems: false,
      getCheckedPrice: [],
      getCheckedTag: [],
      itemPerPage: 8,
      noResult: '',
      quantity: 1,
      cart: {
        items: []
      },
      loadMore: true,
      catFilters: {},

      tagWoo:[],
      selectedTags: [],
      prices:[],
      checkedPriceRanges: new Set(),
      allProducts:[],
      page: 1,
      observer: null,
      pageProduct:[],
      categoryOne: null,
      matchedMenuItem : [],
      isLastMenuItem: [],
      searchQuery: '',
    };

    this.scrollRef = React.createRef();
    this.addToCart = this.addToCart.bind(this);
    this.handleProductDisplay = this.handleProductDisplay.bind(this);
    //this.handleProducts = this.handleProducts.bind(this);
    //this.sortList = this.sortList.bind(this);
    this.handleSort = this.handleSort.bind(this);
    //this.getSortLocal = this.getSortLocal.bind(this);
    //this.getPriceRange = this.getPriceRange.bind(this);
    this.handlePriceRange = this.handlePriceRange.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleAddToCartClick = this.handleAddToCartClick.bind(this);

    this.lastProductRef = React.createRef();
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && Date.now() < user.expiresAt) {
        this.setState({ user: user });
    } else {
        this.setState({ user: { details: {} } });
    }

    const { slug, tag } = this.props.match.params;
    const { itemPerPage } = this.state;
    const getContent = this.props.location.data ? this.props.location.data : '';
    const getSearchedProduct = this.props.location.search ? this.props.location.search.replace('?kw=', '') : '';

    let promises = [];
    promises.push(this.fetchMenus().then(() => console.log('Menus fetched')));

    let fetchProductsPromise;

    if (getSearchedProduct) {
        this.setState({ searchQuery: getSearchedProduct }, () => {
            fetchProductsPromise = this.fetchAllProducts(undefined, undefined, 1, [], undefined, getSearchedProduct, true)
                .then(() => this.fetchAllProductsWoo(null, getSearchedProduct, null, true))
                .then(() => this.fetchPriceRanges());
            promises.push(fetchProductsPromise);
        });
    } else if (tag) {
        fetchProductsPromise = productService.getByTags(tag, 1, itemPerPage)
            .then(products => menuService.getMenuByName(getContent)
                .then(menu => {
                    let category = { name: tag.charAt(0).toUpperCase() + tag.slice(1) };
                    this.setState({ category });
                    this.setupTags(products, menu);
                    return products;
                })
            ).then(() => this.handleProducts());
        promises.push(fetchProductsPromise.then(() => this.fetchPriceRanges()));
    } else if (slug) {
        if (slug === 'hot-offers') {
            categoryService.getCategoryIDBySlug('hot-offers')
                .then(categoryId => {
                    if (categoryId) {
                        this.setState({ categoryOne: categoryId }, () => {
                            this.fetchAllProducts(undefined, undefined, 1, [], this.state.categoryOne)
                                .then(() => this.fetchAllProductsWoo(this.state.categoryOne))
                                .then(() => this.fetchPriceRanges());
                        });
                    } else {
                        console.error('Category ID not found for "hot-offers" slug');
                    }
                })
                .catch(error => {
                    console.error('Error fetching category ID:', error);
                });
        } else {
            fetchProductsPromise = categoryService.getCategoryIDBySlug(slug)
                .then(categoryOne => {
                    this.setState({ categoryOne, page: 1 });
                    return this.fetchAllProducts(this.state.minPrice, this.state.maxPrice, 1, [], categoryOne, null, true)
                        .then(() => this.fetchAllProductsWoo(this.state.categoryOne, null, null, true))
                        .then(() => this.fetchPriceRanges());
                });
            promises.push(fetchProductsPromise);
        }
    } else {
        fetchProductsPromise = this.fetchAllProducts().then(() => this.setState({ noResult: 'Other Products' }))
            .then(() => this.fetchPriceRanges());
        promises.push(fetchProductsPromise);
    }

    Promise.allSettled([
        postService.getBranches('branch', 'branches').then(branchesData => this.setState({ branches: branchesData.items })),
        categoryService.getWooCategories().then(categoriesItems => this.setState({ catwoo: categoriesItems })),
        tagService.getWooTag().then(items => this.setState({ tagWoo: items })),
        ...promises
    ]).then(() => this.setState({ loading: false }));

    const display = localStorage.getItem('productDisplay');
    this.setState({ displayList: display === 'true' ? true : false });
    window.addEventListener("scroll", this.handleScroll);

    settingsService.getPages('products').then(items => this.setState({ pageProduct: items }));
}





  fetchMenus = () => {
    return Promise.all([
        menuService.getMenuByName('default'),
        menuService.getMenuByName('Topbar')
    ]).then(([defaultMenu, topbarMenu]) => {
        // Find the menu item that matches the current pathname
        const matchedMenuItem = defaultMenu.items.find(item => item.url === window.location.href);

        // Check if the last item in the defaultMenu matches the current URL
        const lastMenuItem = defaultMenu.items[defaultMenu.items.length - 1];
        const isLastMenuItem = lastMenuItem.url === window.location.href;

        this.setState({ 
            menu: defaultMenu, 
            topbarMenu, 
            matchedMenuItem,
            isLastMenuItem 
        });
    }).catch(error => {
        console.error('Error fetching menus:', error);
        // Optionally handle the error, e.g., set an error state
    });
};

fetchAllProducts = (min, max, page = 1, accumulatedProducts = [], categoryOne = null, searchQuery = null, searchInNameOnly = false) => {
    const { selectedTags } = this.state;
    const categoryId = categoryOne ? categoryOne[0].id : undefined;

    this.setState({ loadMore: true }); // Start loading

    return productService.getAllProducts(categoryId, selectedTags, min, max, page, 10, searchQuery)
        .then(newProducts => {
            const updatedProducts = [...accumulatedProducts, ...newProducts];

            if (newProducts.length < 10) {
                const finalProducts = searchInNameOnly && searchQuery
                    ? updatedProducts.filter(product =>
                        product.name.toLowerCase().includes(searchQuery.toLowerCase())
                      )
                    : updatedProducts;

                return new Promise((resolve) => {
                    this.setState({ products: finalProducts, allProductsLoaded: true, loadMore: false}, () => {
                        this.fetchPriceRanges(); // Fetch price ranges here
                        resolve(finalProducts);
                    });
                });
            } else {
                return this.fetchAllProducts(min, max, page + 1, updatedProducts, categoryOne, searchQuery, searchInNameOnly);
            }
        })
        .catch(error => {
            console.error('Error fetching products:', error);
            this.setState({ loadMore: false });
            throw error; // Re-throw error to handle it in the calling context
        });
};

fetchAllProductsWoo = (categoryOne = null, searchQuery = null, selectedTags = null, searchInNameOnly = false) => {
    const tags = selectedTags || this.state.selectedTags;
    const search = searchQuery || this.state.searchQuery;

    let allProducts = [];

    this.setState({ loadMore: true }); // Start loading


    const fetchPage = (page) => {
        const categoryId = categoryOne ? categoryOne[0].id : undefined;
        return productService.getAllProducts(categoryId, tags, undefined, undefined, page, 10, search)
            .then(items => {
                allProducts = allProducts.concat(items);
                if (items.length === 10) {
                    return fetchPage(page + 1); // Fetch the next page
                }
                if (searchInNameOnly && search) {
                    allProducts = allProducts.filter(product =>
                        product.name.toLowerCase().includes(search.toLowerCase())
                    );
                }
                return allProducts; // Return all accumulated products
            })
            .catch(error => {
                console.error('Error fetching all products:', error);
                throw error;
            });
    };

    return fetchPage(1).then(allProducts => {
        this.setState({ allProducts, loadMore: false }, () => {
            this.fetchPriceRanges(); // Fetch price ranges here
        });
        return allProducts;
    }).catch(error => {
        console.error('Error fetching all products:', error);
    });
};




//   setupTags(products, menu, category, catFilters = []){
//     //set starting products
//     let dupItems = products.items;
//     let defaultProducts = {};
//     defaultProducts.items = dupItems;

//     //count tags from result
//     let _tags = products.items.map((item) => item.tags).flat(1).sort();
//     let tags = []
//     let count = 0; 
//     for(let i in _tags){
//       let tag = _tags[i];
      
//       if(tag == _tags[i-1]){
//         count += 1;
//         tags.pop();
//       }else{
//         count = 1
//       }

//       tags = [...tags, {tag:tag,count:count}];
//     }

//     tags.sort(function(a, b){
//       return b.count-a.count
//     })

//     if (category && category._id) {
//       this.setState({ menu, tags, products, defaultProducts, category, catFilters })
//     } else {
//       this.setState({ menu, tags, products, defaultProducts, noResult: 'Other Products', catFilters })
//     }
//   }

  componentWillUnmount() {
    // you need to unbind the same listener that was binded.
    window.removeEventListener('scroll', this.handleScroll);
    if (this.state.observer) {
        this.state.observer.disconnect();
    }
  }


  handleScroll () {
    console.log("Scrolled!");

    const { loadMore, allProductsLoaded, categoryOne, minPrice, maxPrice, page } = this.state;

    if (loadMore || allProductsLoaded) return;

    const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight || window.innerHeight;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom) {
        this.setState({ loadMore: true }, () => {
            this.fetchAllProducts(minPrice, maxPrice, page, [], categoryOne)
                .then(() => {
                    // Update page and loadMore state after fetching products
                    this.setState((prevState) => ({
                        page: prevState.page + 1,
                        loadMore: false
                    }));
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                    this.setState({ loadMore: false });
                });
        });
    }

  }

  addToCart = (productId) => {
    // return cartService.fetchNonce()
    // .then(nonce => {
    //     console.log(nonce)
    //     // Use the fetched nonce in your requests
    //     cartService.addToCart(productId, 1, nonce)
    //         .then(data => console.log('Product added to cart:', data))
    //         .catch(error => console.error('Failed to add product to cart:', error));
    // })
    // .catch(error => {
    //     console.error('Failed to fetch nonce:', error);
    // });

    // const { cart } = this.state;

    // if (!cart.items) {
    //   Swal.fire({
    //     position: "top-end",
    //     icon: "error",
    //     title: "An error occured when retrieving your cart.",
    //     showConfirmButton: false,
    //     timer: 3000,
    //   });
    //   return false;
    // }
    
    // cartService.getItems().then(({ items, ...cart }) => {
    //   const newItems = items.reduce((acc, obj) => {
    //     const index = acc.findIndex((v) => v.p === obj.p);
    //     if (index > -1) {
    //       acc[index].q += obj.q
    //       return acc;
    //     };
    //     return acc.concat(obj);
    //   }, [{
    //     p: id,
    //     n: name,
    //     i: image,
    //     s: slug,
    //     c: cost,
    //     q: 1,
    //   }]);

    //   cartService.addItem({
    //     ...cart,
    //     items: newItems
    //   }).then((result) => {
    //     if (result.success) {
    //       Swal.fire({
    //         position: "top-end",
    //         icon: "success",
    //         title: name + " has been added to your shopping cart.",
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    //   });
    // });
  }

  //if products display button clicked
  handleProductDisplay(e) {
    e.preventDefault();
    this.setState({ displayList: !this.state.displayList }, () => { localStorage.setItem('productDisplay', this.state.displayList); });
  }

//   handleProducts() {
//     this.getPriceRange();
//     this.getSortLocal();
//   }

  //on reload/ go back to productlist page, check localStorage for prev product sorting
//   getSortLocal() {
//     const getSort = localStorage.getItem('korgproductsSort') || 'newest';

//     if (getSort) {
//       const { productsSort } = this.state;
//       const toSort = productsSort.filter((sort) => sort.sortBy.includes(getSort));
//       const sortBy = toSort[0] ? toSort[0].sortBy : '';
//       this.setState({ sortBy: sortBy })
//       this.sortList(sortBy);
//     }
//   }

  //if product sorting dropdown option changes
  handleSort(event) {
    const sortBy = event.target.value;
    let sortedProducts = [...this.state.products];

    switch (sortBy) {
      case 'newest':
        sortedProducts.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
        break;
      case 'oldest':
        sortedProducts.sort((a, b) => new Date(a.date_created) - new Date(b.date_created));
        break;
      case 'low-to-high':
        sortedProducts.sort((a, b) => parseFloat(a.price.replace(/,/g, '')) - parseFloat(b.price.replace(/,/g, '')));
        break;
      case 'high-to-low':
        sortedProducts.sort((a, b) => parseFloat(b.price.replace(/,/g, '')) - parseFloat(a.price.replace(/,/g, '')));
        break;
      case 'desc-a-z':
        sortedProducts.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'desc-z-a':
        sortedProducts.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }

    this.setState({ sortBy, products: sortedProducts });
  }

//   getPriceRange() {
//     const { productsRange, products } = this.state;
//     var ranges = [];

//     productsRange.map(range => {
//       var min = range.value.split(' - ')[0].replace(',', '');
//       var max = range.value.split(' - ')[1].replace(',', '');
//       ranges.push({
//         value: range.value,
//         min: min,
//         max: max,
//         items: products && products.items ? products.items.filter(item => inRange(item.price.replace(',', ''), min, max === "higher" ? 1000000 : max)).length : 0
//       })
//       return range
//     })

//     this.setState({ productsRange: ranges })
//     //this.handlePriceRange();
//   }

  //if price range checkboxes checked/unchecked
  handlePriceRange = (event) => {
    const { value, checked } = event.target;
    const { prices , categoryOne } = this.state;

    // Find the selected price range object
    const selectedRange = prices.find(range => range.id === parseInt(value));

    // Create a copy of the existing set
    const checkedPriceRanges = new Set(this.state.checkedPriceRanges);

    // Update the copied set based on the checkbox state
    if (checked) {
        checkedPriceRanges.add(selectedRange);
    } else {
        checkedPriceRanges.forEach(range => {
            if (range.id === selectedRange.id) {
                checkedPriceRanges.delete(range);
            }
        });
    }

    // Calculate the overall min and max prices from all selected ranges
    let overallMinPrice = Infinity;
    let overallMaxPrice = -Infinity;
    checkedPriceRanges.forEach(range => {
        const rangeMin = parseFloat(range.acf.minimum_price.replace(/,/g, ''));
        const rangeMax = range.acf.maximum_price === "higher" ? Infinity : parseFloat(range.acf.maximum_price.replace(/,/g, ''));

        if (rangeMin < overallMinPrice) {
            overallMinPrice = rangeMin;
        }
        if (rangeMax > overallMaxPrice) {
            overallMaxPrice = rangeMax;
        }
    });

    // Update the state with the new set
    this.setState({ checkedPriceRanges: Array.from(checkedPriceRanges) }, () => {
        // After updating selected ranges, fetch products based on combined range
        if (checkedPriceRanges.size > 0) {
            this.fetchAllProducts(overallMinPrice === Infinity ? undefined : overallMinPrice, overallMaxPrice, 1, [], categoryOne);
        } else {
            // If no price range is selected, fetch all products
            this.fetchAllProducts(undefined, undefined, 1, [], categoryOne);
        }
    });

  
  }

  handleTagChange = (event) => {
    const { value, checked } = event.target;
    let selectedTags = [...this.state.selectedTags];

    if (checked) {
        selectedTags.push(value);
    } else {
        selectedTags = selectedTags.filter(tag => tag !== value);
    }

    this.setState({ selectedTags }, () => {
        // After updating selected tags, fetch products based on selected tags, categoryOne, and searchQuery
        const { categoryOne, searchQuery } = this.state;
        this.fetchAllProducts(undefined, undefined, 1, [], categoryOne, searchQuery, selectedTags);
    });
};


fetchPriceRanges = () => {
    fetch('/wp-json/wp/v2/price-range')
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch price ranges');
        }
        return response.json();
    })
    .then(data => {
        const updatedPrices = data.map(range => {
            const minPrice = parseFloat(range.acf.minimum_price.replace(/,/g, ''));
            let maxPrice;
            if (range.acf.maximum_price === 'higher') {
                maxPrice = Infinity;
            } else {
                maxPrice = parseFloat(range.acf.maximum_price.replace(/,/g, ''));
            }

            // Filter products for this price range
            const productsInRange = this.state.allProducts.filter(product => {
                const productPrice = parseFloat(product.price.replace(/,/g, ''));
                return productPrice >= minPrice && productPrice <= maxPrice;
            });

            // Get the count of products in this price range
            const totalProductsInRange = productsInRange.length;

            return { ...range, totalProducts: totalProductsInRange };
        });

        this.setState({ prices: updatedPrices, loading: false });
    })
    .catch(error => {
        console.error('Error fetching or processing price ranges:', error);
        this.setState({ error: error.message, loading: false });
    });
};



componentDidUpdate(prevProps, prevState) {
    // Check if products state has changed
    if (prevState.products !== this.state.products) {
        // If products state has changed, update totalProductsInRange for all price ranges
        this.updateTotalProductsInRange();
    }
}

updateTotalProductsInRange = () => {
    const { prices } = this.state;
    const updatedPrices = prices.map(range => {
        const minPrice = parseFloat(range.acf.minimum_price.replace(/,/g, ''));
        const maxPrice = range.acf.maximum_price === 'higher' ? Infinity : parseFloat(range.acf.maximum_price.replace(/,/g, ''));

        const totalProductsInRange = this.state.products.filter(product => {
            const productPrice = parseFloat(product.price.replace(/,/g, ''));
            return productPrice >= minPrice && productPrice <= maxPrice;
        }).length;

        return { ...range, totalProducts: totalProductsInRange };
    });

    // Update state with the updated price ranges
    this.setState({ prices: updatedPrices });
};

handleAddToCartClick = (productId) => {
    // Fetch the cart nonce
    cartService.getAllCart()
        .then(nonce => {
            console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
            // Add the product to the cart using the fetched nonce
            return cartService.addToCart(productId, 1, nonce);
        })
        .then(data => {
            console.log('Product added to cart:', data);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: data.name + " has been added to your shopping cart.",
                showConfirmButton: false,
                timer: 1500,
              });
        })
        .catch(error => {
            console.error('Failed to add product to cart:', error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "An error occured when retrieving your cart.",
                showConfirmButton: false,
                timer: 3000,
              });
        });
};

  render() {
    const { matchedMenuItem , isLastMenuItem, categoryOne ,pageProduct, prices, tagWoo,loading, user, menu, topbarMenu, products, displayList, checkedItems, productsSort, sortBy, branches, priceRange, noResult,loadMore } = this.state;
    // const getPriceRange = JSON.parse(localStorage.getItem('korgPriceRange'));
    // const getCheckedPrice = getPriceRange ? getPriceRange : [];
    // const getTags = JSON.parse(localStorage.getItem('korgProdTags'));
    // const getCheckedTags = getTags ? getTags : [];
    const getProdItems = products && products
      .filter((item) => checkedItems || priceRange.length > 0 ? priceRange.includes(item.id) : item.price && item.price !== "")
      
    let getResult;

    if (noResult) {
      getResult = <h5 className="m-0">{noResult}</h5>
    } else {
      getResult = <h5 className="m-0">{getProdItems && getProdItems.length > 0 ? "Showing 1-" + getProdItems.length + " out of (" + getProdItems.length + ") " : 'No '}results found</h5>
    }

    const pathname = window.location.pathname;

    console.log(getProdItems)

    return (
      <div>
        <PreLoader loading={loading} />
        <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
        <div className="jumbotron page-title py-5">
          <div className="container"><h1 className="text-white">{!categoryOne ? pageProduct[0]?.title?.rendered : categoryOne[0]?.name}</h1></div>
        </div>
        {/* && category && products.items  */}
        {products &&
          <section className="main-content">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-transparent m-0">
                      <li className="breadcrumb-item"><a href="/">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <a href={pathname || "/product"}>{!categoryOne ? "Products": categoryOne[0]?.name}</a>
                      </li>
                    </ol>
                  </nav>
                  <hr className="m-0 mb-4" />
                </div>

                {/* {!category.parent &&
                  <div className="col-12 mb-5">
                    <div className="row">
                      {category.subcategories && category.subcategories.map((cat, index) =>
                        <div className="col-sm-1 col-md-6 col-lg-3 mb-3" key={index}>
                          <a href={"/" + cat.slug} style={{ "backgroundImage": `url(${cat.image})` }} className="prod-cat-card card">
                            <div className="card-body">
                              <p className="card-text">{cat.description || 'category description'}</p>
                            </div>
                            <footer className="card-footer">
                              <h5 className="card-title">{cat.name} <i className="fas fa-long-arrow-alt-right"></i></h5>
                            </footer>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                } */}

                {matchedMenuItem && (
                    <div className="col-12 mb-5">
                        <div className="row">
                            {matchedMenuItem.child_items && matchedMenuItem.child_items.map((cat, index) =>
                                <div className="col-sm-1 col-md-6 col-lg-3 mb-3" key={index}>
                                    <a href={cat.url} style={{ "backgroundImage": `url(${cat.attr_title})`, border:'none', borderRadius:0 }} className="prod-cat-card card">
                                        <div className="card-body">
                                            <p className="card-text">{cat.post_content}</p>
                                        </div>
                                        <footer className="card-footer">
                                            <h5 className="card-title">{cat.title} <i className="fas fa-long-arrow-alt-right"></i></h5>
                                        </footer>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {!isLastMenuItem && products && products &&
                  <div className="col-sm-12 col-md-4 col-lg-3">
                    <h5 className="mt-2">Price Range</h5>
                    <ul className="list-group list-group-flush mb-5">
                      {/* {productsRange && productsRange.map((range, index) =>
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" name="itemPriceRange" onChange={this.handlePriceRange}
                              type="checkbox" id={"rangeCheckbox" + index} value={range.value} checked={getCheckedPrice.includes(range.value)} />
                            <label className="form-check-label" htmlFor={"rangeCheckbox" + index}>{range.value.split(" - ").map((v) => v === "higher" ? "Higher" : formatPrice(v)).join(" - ")}</label>
                          </div>
                          <span className="badge badge-light badge-pill">{range.items}</span>
                        </li>
                      )} */}
                        {prices.map((range, index) => (
                            
                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        name="itemPriceRange"
                                        onChange={this.handlePriceRange}
                                        type="checkbox"
                                        id={"rangeCheckbox" + index}
                                        value={range.id} // Assuming price range object has an 'id' property
                                        //checked={checkedPriceRanges.has(range.id)} // Check if the price range is checked
                                    />
                                    <label className="form-check-label" htmlFor={"rangeCheckbox" + index}>
                                        {range.acf.minimum_price} - {range.acf.maximum_price}
                                    </label>
                                </div>
                                <span className="badge badge-light badge-pill">{range.totalProducts}</span>
                            </li>
                        ))}
                    </ul>

                    <h5 className="mt-2">Tags</h5>
                    {tagWoo &&
                        <ul className="list-group list-group-flush mb-5">
                            {tagWoo.length > 0 && tagWoo.map((tag, index) =>
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            name="itemTag"
                                            onChange={this.handleTagChange}
                                            type="checkbox"
                                            id={"inlineCheckbox" + index}
                                            value={tag.id}
                                        />
                                        <label className="form-check-label" htmlFor={"inlineCheckbox" + index}>{tag.name}</label>
                                    </div>
                                    <span className="badge badge-light badge-pill">{tag.count}</span>
                                </li>
                            )}
                        </ul>
                    }
                  </div>
                }
                {/* Products */}
                {!isLastMenuItem && products &&
                  <div className="col-sm-12 col-md-8 col-lg-9">
                    {/* product list toolbar */}
                    <div className="d-flex product-list-toolbar align-items-lg-center justify-content-between mb-3 flex-column flex-lg-row">
                      <div className="d-flex">{getResult}</div>
                      <div className="d-flex">
                        {productsSort &&
                          <div className="form-inline mr-5">
                            <label htmlFor="sr-only" className="mr-2">Sort by: </label>
                            <select name="" id="" className="form-control" value={sortBy} onChange={this.handleSort}>
                              {productsSort.map((sort, index) =>
                                <option key={index} value={sort.sortBy}>{sort.name}</option>
                              )}
                            </select>
                          </div>
                        }
                        <div className="d-flex">
                          <Link to="" onClick={(e) => this.handleProductDisplay(e)} className={displayList ? "btn btn-icon mr-1" : "btn btn-icon mr-1 disabled"}><FontAwesomeIcon icon={faTh} /></Link>
                          <Link to="" onClick={(e) => this.handleProductDisplay(e)} className={displayList ? "btn btn-icon disabled" : "btn btn-icon"}><FontAwesomeIcon icon={faList} /></Link>
                        </div>
                      </div>
                    </div> 
                    {/* end: product list toolbar */}
                    {/* {products && products &&
                      <>
                        
                          <div className="row">
                            {this.state.loadMore !== "disabled" && <PreLoader
                              loading={!this.state.loadMore}
                              style={{
                                position: "absolute",
                                opacity: 0.9,
                                height: "100%",
                                alignItems: "flex-end",
                              }}
                            />}
                            {products.map((item) =>
                              <div className="col-md-12" key={item.id}>
                                <div className="row">
                                  <div className="col-lg-2">
                                    {item.images &&
                                      <Link to={'/product/'+item.slug}><img src={item.images[0]?.src} className="w-100" alt="..." /></Link>
                                    }
                                  </div>
                                  <div className="col-lg">
                                    <Link to={'/product/' + item.slug}><h5 className="card-title">{item.name}</h5></Link>
                                    <span className="card-text price mb-1"><strong>{formatPrice(item.price, { minimumFractionDigits: 0 })}</strong></span>
                                    {item.stock_quantity <= 0 &&
                                      <span className="disabled float-right">Out of Stock</span>
                                    }
                                    {item.stock_quantity > 0 &&
                                      <button disabled={item.stock_quantity <= 0} className="btn btn-primary float-right" 
                                    //   onClick={() => {
                                    //       if (item.stock_quantity <= 0) return;
                                    //       this.addToCart(item._id, item.name, item.slug, item.mainImage, item.price)
                                    //     }}
                                        
                                        >Add to Cart</button>
                                      }
                                  </div>
                                </div>
                                <hr />
                              </div>
                            )}
                          </div>
                          {/* :
                          
                          <div className="position-relative">
                            {this.state.loadMore !== "disabled" && <PreLoader
                              loading={!this.state.loadMore}
                              style={{
                                position: "absolute",
                                opacity: 0.9,
                                height: "100%",
                                alignItems: "flex-end",
                              }}
                            />}
                            <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-4">

                              {getProdItems.map((item) => {
                                const isNew = item.new;
                                const isSale = item.sale;

                                return (
                                  <div className="col mb-sm-3" key={item._id}>
                                    <div className="card product-card-single mb-sm-3 h-100">


                                      <span className={isSale ? 'sale' : isNew ? 'new' : ''}>
                                        {isSale ? 'Sale' : isNew ? 'New' : ''}
                                      </span>

                                      {item.mainImage &&
                                        <Link to={'/product/'+item.slug}><img src={item.mainImage} className="card-img-top" alt="..." /></Link>
                                      }
                                      <div className="card-body">
                                      <Link to={'/product/' + item.slug}><h5 className="card-title">{item.name}</h5></Link>
                                      </div>
                                      <div className="card-footer">
                                        {item.retailPrice &&
                                            <small><s className="text-muted">{formatPrice(item.retailPrice, { minimumFractionDigits: 0 })}</s></small>
                                          }
                                        <p className="card-text price mb-1"><strong>{formatPrice(item.price, { minimumFractionDigits: 0 })}</strong></p>
                                        <button disabled={item.stock <= 0} className="btn btn-primary" onClick={() => {
                                          if (item.stock <= 0) return;
                                          this.addToCart(item._id, item.name, item.slug, item.mainImage, item.price)
                                        }}>Add to Cart</button>
                                      </div>
                                    </div>
                                  </div>
                                )

                              }

                              )}
                            </div>
                          </div> */}
                        
                        {/* {products && products &&
                          <div ref={this.scrollRef} id="loadingPage" style={{ display: 'block' }}></div>
                        }
                    </>
                    } */} 


                    {loadMore ? (
                        <div className="loading-indicator">Loading...</div>
                    ) : (
                        !isLastMenuItem && products && products &&
                            <>
                              {displayList ?
                                <div className="row">
                                  {/* {loadMore && <PreLoader
                                    loading={!this.state.loadMore}
                                    style={{
                                      position: "absolute",
                                      opacity: 0.9,
                                      height: "100%",
                                      alignItems: "flex-end",
                                    }}
                                  />} */}
                                  {getProdItems.map((item, index) =>
                                    <div className="col-md-12" key={item._id}>
                                      <div className="row">
                                        <div className="col-lg-2">
                                          {item.images &&
                                            <Link to={'/product/'+item.slug}><img src={item.images[0]?.src} className="w-100" alt="..." /></Link>
                                          }
                                        </div>
                                        <div className="col-lg">
                                          <Link to={'/product/' + item.slug}><h5 className="card-title">{item.name}</h5></Link>
                                          <span className="card-text price mb-1"><strong>{formatPrice(item.price)}</strong></span>
                                          {item.stock_quantity <= 0 &&
                                            <span className="disabled float-right">Out of Stock</span>
                                          }
                                          {item.stock_quantity > 0 &&
                                            <button disabled={item.stock_quantity <= 0} className="btn btn-primary float-right" onClick={() => {
                                                if (item.stock_quantity <= 0) return;
                                              //   this.addToCart(item.id)
                                                this.handleAddToCartClick(item.id);
                                              }}>Add to Cart</button>
                                            }
                                        </div>
                                      </div>
                                      <div ref={this.scrollRef} id="loadingPage"></div>
                                      <hr />
                                    </div>
                                  )}
                                </div>
                                :
                                <div className="position-relative">
                                  {/* {loadMore && <PreLoader
                                    loading={!this.state.loadMore}
                                    style={{
                                      position: "absolute",
                                      opacity: 0.9,
                                      height: "100%",
                                      alignItems: "flex-end",
                                    }}
                                  />} */}
                                  <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-4">
      
                                    {getProdItems.map((item, index) => {
                                       const isNew = item.tags.some(tag => tag.slug === 'new');
                                       const isSale = item.tags.some(tag => tag.slug === 'sale');
                     
                                      return (
                                        <div className="col mb-sm-3" key={item._id}>
                                          <div className="card product-card-single mb-sm-3 h-100">
      
      
                                            <span className={isSale ? 'sale' : isNew ? 'new' : ''}>
                                              {isSale ? 'Sale' : isNew ? 'New' : ''}
                                            </span>
      
                                            {item.images &&
                                              <Link to={'/product/'+item.slug}><img src={item.images[0].src} className="card-img-top" alt="..." /></Link>
                                            }
                                            <div className="card-body">
                                            <Link to={'/product/' + item.slug}><h5 className="card-title">{item.name}</h5></Link>
                                            </div>
                                            <div className="card-footer">
                                              {item.on_sale == true &&
                                                <small><s className="text-muted">{formatPrice(item.regular_price, { minimumFractionDigits: 0 })}</s></small>
                                            }
                                            <p className="card-text price mb-1">
                                                <strong>{ item.on_sale !== false ? formatPrice(item.price, { minimumFractionDigits: 0 }) : formatPrice(item.regular_price, { minimumFractionDigits: 0 }) }</strong>
                                            </p>
                                              <button disabled={item.stock_quantity <= 0} className="btn btn-primary" onClick={() => {
                                                if (item.stock_quantity <= 0) return;
                                                this.handleAddToCartClick(item.id);
                                              }}>Add to Cart</button>
                                            </div>
                                          </div>
                                          {index === item.length - 1 && (
                                              <div ref={this.lastProductRef}></div> // Use the ref for the last product
                                          )}
                                        </div>
                                      )
      
                                    }
      
                                    )}
                                  </div>
                                </div>
                              }
                               <div ref={this.scrollRef} id="loadingPage"></div>
                            </>
                          

                    )}
                     
                  
                  </div>
                }

               
                
                 
              </div>
            </div>
          </section>
        }
        <MainFooter menu={menu} branches={branches} />
      </div>
    );
  }
}

export { ProductList };